import React, { Component } from "react";
import Select from "react-select";
import { AuthUserContext, withAuthorization } from "../Auth/Session";
import { toast } from "react-toastify";
import { trackPromise } from "react-promise-tracker";
import * as ROUTES from "../../constants/routes";
import * as ROLES from "../../constants/roles";
import * as COUNTRIES from "../../constants/countries";
import * as APIS from "../../constants/apis";
import API from "../../constants/api";

import { isSuperAdmin } from "../../constants/validations";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { getCusomerAction } from "../../redux/actions/CustomerAction";
import { getAllPermission, getAllRoles, registerUsersAction } from "../../redux/actions/UsersAction";
import mailgunApi from "../../constants/mailgunApi";

const getCustomers = () => {
  return (dispatch) => {
    dispatch(getCusomerAction());
  };
};

const getPermissions = () => {
  return (dispatch) => {
    dispatch(getAllPermission());
  };
};

const getRoles = () => {
  return (dispatch) => {
    dispatch(getAllRoles());
  };
};

const INITIAL_STATE = {
  display_name: "",
  email: "",
  password: "",
  only_reports: false,
  customer_id: {},
  customer_product: [],
  role_id: null,
  permission_id: null,
  roles: [],
  permissions: [],
  customers: [],
  is_can_see_depths: false,
  isShowAndHidePassword: false,
  language: "",
  country: "",
  active: null,
  isSuperAdmin: null,
  restricted_admin: false,
  role_name: "",
  is_manager: false,
};

class UserNewItem extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  async componentDidMount() {
    if (!this.props.premissions) {
      this.props.getPermissions();
    }
    if (!this.props.roles) {
      this.props.getRoles();
    }
    this.props.getCustomers();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.customers || this.props.customers !== prevProps.customers) {
      if (this.props.customers && this.props.roles && this.props.permissions) {
        console.log("fake");
        this.setState({
          customers: this.props.customers,
          roles: this.props.roles,
          permissions: this.props.permissions,
        });
      }
    }
  }

  onSubmit = (event) => {
    let data = this.state;
    delete data.roles;
    delete data.permissions;
    delete data.customers;
    data.active = true;
    if (data.role_name === "GERENTE") {
      data.only_reports = false;
      data.role_name = "CUSTOMER";
    }
    event.preventDefault();
    return trackPromise(
      API.registerUser(data)
        .then((res) => {
          let message = res.message;
          if (!message) {
            if (this.state.customer_product.length > 0) {
              const body = {
                email: data.email,
                username: data.display_name,
                customers: this.state.customer_product,
              };
              return mailgunApi
                .sendDemoInitEmail(body)
                .then((json) => {
                  toast.success(this.props.t("alerts.users-item-13"));
                  this.props.history.push(ROUTES.USERS);
                })
                .catch((err) => {
                  toast.error(err.response.data.message);
                });
            } else {
              toast.success(this.props.t("alerts.users-item-13"));
              this.props.history.push(ROUTES.USERS);
            }
          }
        })
        .catch((err) => {
          toast.error(err.response.data.message);
        })
    );
  };

  handleShowHidePassword = (event) => {
    this.setState({
      isShowAndHidePassword: !this.state.isShowAndHidePassword,
    });
  };

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onChangeCheckbox = (event) => {
    this.setState({ [event.target.name]: event.target.checked });
  };

  onChangeSubmit = (objects) => {
    const array = [];
    for (let i = 0; i < objects.length; i++) {
      if (
        objects[i].type === "Demo 14 dias" ||
        objects[i].type === "Demo 2 meses"
      ) {
        this.setState({
          customer_product: [
            ...this.state.customer_product,
            { id: objects[i].value, name: objects[i].label },
          ],
        });
      }
      array.push(objects[i].value);
    }

    this.setState({ customer_id: array });
  };

  onChangeRolesAction = (event) => {
    let rol_name = event.target.value;

    if (rol_name === "SADMIN") {
      this.setState({
        role_id: 1,
        role_name: rol_name,
        isSuperAdmin: true,
        restricted_admin: false,
        is_manager: false,
      });
    } else if (rol_name === "ADMIN") {
      this.setState({
        role_id: 1,
        role_name: rol_name,
        isSuperAdmin: null,
        restricted_admin: true,
        is_manager: false,
      });
    } else if (rol_name === "CUSTOMER") {
      this.setState({
        role_id: 2,
        role_name: rol_name,
        isSuperAdmin: null,
        restricted_admin: false,
        is_manager: false,
      });
    } else if (rol_name === "ANALYST") {
      this.setState({
        role_id: 3,
        role_name: rol_name,
        isSuperAdmin: null,
        restricted_admin: false,
        is_manager: false,
      });
    } else if (rol_name === "TECHNICIAN") {
      this.setState({
        role_id: 4,
        role_name: rol_name,
        isSuperAdmin: null,
        restricted_admin: false,
        is_manager: false,
      });
    } else if (rol_name === "GERENTE") {
      this.setState({
        role_id: 2,
        role_name: "GERENTE",
        isSuperAdmin: null,
        restricted_admin: false,
        is_manager: true,
      });
    }
  };

  render() {
    const {
      display_name,
      email,
      password,
      only_reports,
      customer_id,
      role_id,
      role_name,
      permission_id,
      roles,
      permissions,
      customers,
      is_can_see_depths,
      isShowAndHidePassword,
      language,
      country,
      is_manager
    } = this.state;

    const optionsSelect =
      !!customers &&
      customers.map((customer) => {
        return {
          value: customer.id,
          type: customer.product,
          label: customer.name,
        };
      });

    return (
      <AuthUserContext.Consumer>
        {(authUser) => (
          <div className="container-fluid mt-100">
            <h3>{this.props.t("users.users-register")}</h3>
            <br />
            <br />
            <form onSubmit={this.onSubmit}>
              <div className="form-group">
                <div className="row">
                  <div className="col-sm-2">
                    <label htmlFor="emailInput">
                      {this.props.t("users.users-th-1")}
                    </label>
                  </div>
                  <div className="col-sm-10">
                    <input
                      id="emailInput"
                      name="email"
                      value={email}
                      onChange={this.onChange}
                      type="email"
                      className="form-control"
                      placeholder={this.props.t("users.users-th-1")}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="row">
                  <div className="col-sm-2" style={{ position: "relative" }}>
                    <label htmlFor="passwordInput">
                      {this.props.t("users.users-password")}
                    </label>
                  </div>
                  <div className="col-sm-10">
                    <input
                      id="passwordInput"
                      name="password"
                      value={password}
                      onChange={this.onChange}
                      type={isShowAndHidePassword ? "text" : "password"}
                      className="form-control"
                      placeholder={this.props.t("users.users-password")}
                      required
                    />
                    <button
                      type="button"
                      className="button-password"
                      onClick={this.handleShowHidePassword}
                      style={{ marginTop: "-27px", marginRight: "10px" }}
                    >
                      {isShowAndHidePassword ? (
                        <img
                          src={process.env.PUBLIC_URL + "/images/invisible.png"}
                        />
                      ) : (
                        <img src={process.env.PUBLIC_URL + "/images/ver.png"} />
                      )}
                    </button>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="row">
                  <div className="col-sm-2">
                    <label htmlFor="roleIdInput">
                      {this.props.t("users.users-language")}
                    </label>
                  </div>
                  <div className="col-sm-10">
                    <select
                      className="form-control"
                      placeholder={this.props.t("users.users-language")}
                      id="roleIdInput"
                      name="language"
                      value={language}
                      onChange={this.onChange}
                    >
                      <option value="">
                        {this.props.t("users.users-language-select")}
                      </option>
                      <option value="es">Español</option>
                      <option value="pt">Portugues</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="row">
                  <div className="col-sm-2">
                    <label htmlFor="countryIdInput">
                      {this.props.t("users.users-country")}
                    </label>
                  </div>
                  <div className="col-sm-10">
                    <select
                      className="form-control"
                      placeholder={this.props.t("users.users-country")}
                      id="countryIdInput"
                      name="country"
                      value={country}
                      onChange={this.onChange}
                      >
                      <option value="">{this.props.t("users.users-country-select")}</option>
                      {COUNTRIES.COUNTRIES.map((country) => {
                          return (
                          <option key={country.id} value={country.name}>
                            {country.name}
                          </option>
                          );
                        })}
                    </select>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="row">
                  <div className="col-sm-2">
                    <label htmlFor="nameInput">
                      {this.props.t("users.users-th-2")}
                    </label>
                  </div>
                  <div className="col-sm-10">
                    <input
                      id="nameInput"
                      name="display_name"
                      value={display_name}
                      onChange={this.onChange}
                      type="text"
                      className="form-control"
                      placeholder={this.props.t("users.users-th-2")}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="row">
                  <div className="col-sm-2">
                    <label htmlFor="roleIdInput">
                      {this.props.t("users.users-th-3")}
                    </label>
                  </div>
                  <div className="col-sm-10">
                    <select
                      className="form-control"
                      placeholder={this.props.t("users.users-th-2")}
                      id="roleIdInput"
                      name="role_id"
                      value={role_name}
                      onChange={this.onChangeRolesAction}
                    >
                      <option value="">
                        {this.props.t("users.users-rol-select")}
                      </option>
                      {isSuperAdmin(
                        authUser.roles,
                        authUser.restricted_admin
                      ) ? (
                        <>
                          <option value="SADMIN">SUPER ADMINISTRADOR</option>
                          <option value="ADMIN">ADMINISTRADOR</option>
                        </>
                      ) : null}
                      <option value="GERENTE">GERENTE</option>
                      <option value="CUSTOMER">CLIENTE</option>
                      <option value="ANALYST">ANALISTA</option>
                      <option value="TECHNICIAN">TECNICO</option>
                      {/* {
                        !!roles && roles.map((rol, index) => {
                          let names = ["SUPER ADMINISTRADOR", "ADMINISTRADOR", "CLIENTE", "ANALISTA", "TECNICO"];
                          return <option
                            key={rol.id}
                            value={rol.id}>
                            {names[index]}
                          </option>;
                        })
                      } */}
                    </select>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="row">
                  <div className="col-sm-2">
                    <label htmlFor="permissionIdInput">
                      {this.props.t("users.users-th-4")}
                    </label>
                  </div>
                  <div className="col-sm-10">
                    <select
                      className="form-control"
                      placeholder={this.props.t("users.users-th-4")}
                      id="permissionIdInput"
                      name="permission_id"
                      value={permission_id}
                      onChange={this.onChange}
                    >
                      <option value="">
                        {this.props.t("users.users-select")}
                      </option>
                      {!!permissions &&
                        permissions.map((item) => {
                          let str = "";
                          let names = ["CREAR", "EDITAR", "ELIMINAR", "VER"];
                          Object.entries(item.permissions).forEach(
                            (permission, index) => {
                              let separator =
                                index < Object.keys(item.permissions).length - 1
                                  ? " / "
                                  : "";
                              let yesno = !!permission[1]
                                ? names[index] + separator
                                : "";
                              str = str + yesno;
                            }
                          );
                          return (
                            <option key={item.id} value={item.id}>
                              {str}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                </div>
              </div>
              {role_id == "2" ||
                role_id == "4" ||
                role_id == "3" ||
                (role_id == "1" && this.state.isSuperAdmin === null) ? (
                <div className="form-group" id="groupCustomerId">
                  <div className="row">
                    <div className="col-sm-2">
                      <label htmlFor="customerIdInput">
                        {this.props.t("users.users-th-5")}
                      </label>
                    </div>
                    <div className="col-sm-10">
                      <Select
                        isMulti
                        name="colors"
                        options={optionsSelect}
                        onChange={this.onChangeSubmit}
                        className="basic-multi-select"
                        classNamePrefix="select"
                      />
                    </div>
                  </div>
                </div>
              ) : null}
              {role_id == "2" || role_id == "4" ? (
                <>
                  <div className="form-group">
                    <div className="row">
                      <div className="col-sm-2 mt-4">
                        <label htmlFor="permissionIdInput">
                          {this.props.t("users.users-depths")}
                        </label>
                      </div>
                      <div className="col-sm-10 mt-4">
                        <div class="form-check form-switch">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="flexSwitchCheckChecked"
                            name="is_can_see_depths"
                            onChange={this.onChangeCheckbox}
                            checked={is_can_see_depths}
                          />
                          <label
                            class="form-check-label"
                            for="flexSwitchCheckChecked"
                          >
                            {this.props.t("users.users-yes-no")}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
              {role_id == "2" && !is_manager ? (
                <div className="form-group" id="groupOnlyReports">
                  <div className="row">
                    <div className="col-sm-2">
                      <label htmlFor="onlyReportsInput">
                        {this.props.t("users.users-just-reports")}
                      </label>
                    </div>
                    <div className="col-sm-10">
                      <input
                        id="onlyReportsInput"
                        name="only_reports"
                        type="checkbox"
                        checked={only_reports}
                        onChange={this.onChangeCheckbox}
                      />
                      <label
                        class="form-check-label ml-2"
                        for="onlyReportsInput"
                      >
                        {this.props.t("users.users-yes-no")}
                      </label>
                    </div>
                  </div>
                </div>
              ) : null}
              <div className="row">
                <div className="col-md-12 text-center">
                  <button type="submit" className="btn btn-primary">
                    <i className="fa fa-save"></i>{" "}
                    {this.props.t("globals.simple-save")}
                  </button>
                </div>
              </div>
            </form>
          </div>
        )}
      </AuthUserContext.Consumer>
    );
  }
}

const structuredSelector = createStructuredSelector({
  roles: (state) => state.users.roles,
  permissions: (state) => state.users.permissions,
  customers: (state) => state.customers.customers,
});

const mapDispatchToProps = { getCustomers, getPermissions, getRoles };

const condition = (authUser) => !!authUser && authUser.roles === ROLES.ADMIN;

export default withAuthorization(condition)(
  connect(structuredSelector, mapDispatchToProps)(UserNewItem)
);
